import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

// Restore the saved login state before the first route navigation.
store.commit("RESTORE_USER_DATA");

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
